class InfiniteSliderComponent extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;
  }

  update() {
    super.update();
    // Keep buttons enabled to allow looping back
    if (this.prevButton) this.prevButton.removeAttribute('disabled');
    if (this.nextButton) this.nextButton.removeAttribute('disabled');
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    
    // Check if we are at the beginning or the end
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.totalPages;
    
    let targetScrollPosition = 0;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      // Rewind to the end
      targetScrollPosition = this.slider.scrollWidth - this.slider.clientWidth;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      // Rewind to the beginning
      targetScrollPosition = 0;
    } else {
      // Normal scroll
      const itemOffsetWidth = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      targetScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * itemOffsetWidth
          : this.slider.scrollLeft - step * itemOffsetWidth;
    }
        
    this.slider.scrollTo({
      left: targetScrollPosition,
      behavior: 'smooth'
    });
  }
}

customElements.define('infinite-slider-component', InfiniteSliderComponent);
